import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Login } from '@ww/login-ui-components';
import { shouldStartFronteggLogin } from 'utils/frontegg-user';

export function FronteggAwareLogin(): JSX.Element {
  const [searchParams] = useSearchParams();
  const isFronteggLogin = shouldStartFronteggLogin(searchParams);

  return <Login prefix="/" isFronteggLogin={isFronteggLogin} />;
}
